module.exports = __webpack_public_path__ + "img/52394567.b6095177.png";